import { Step } from 'react-joyride';

const CompanySettingsTourSteps: Step[] = [
  {
    target: '.tour-title',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Bienvenido a <strong>Configuración de la empresa</strong>. Aquí defines
        cómo funciona tu negocio en Bookoll: privacidad, reservas, correos
        automáticos y recordatorios. Todos los cambios que hagas afectan
        directamente a la experiencia de tus clientes y empleados.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-card-general',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Esta es la sección de <strong>Configuración general</strong>. Aquí
        puedes ver el <strong>idioma</strong> y la <strong>zona horaria </strong>
        de tu empresa. Por ahora, están fijos en Español y Europe/Madrid.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-switch-privada',
    content: (
      <div style={{ textAlign: 'justify' }}>
        <strong>Empresa privada</strong>: al activarlo, tu negocio deja de
        aparecer en el buscador público de Bookoll. Solo podrán acceder a tu
        perfil y reservar quienes tengan el enlace directo o el QR.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-switch-online',
    content: (
      <div style={{ textAlign: 'justify' }}>
        <strong>Reservas online</strong>: controla si los clientes pueden
        reservar citas por su cuenta desde la web. Si lo desactivas, solo tú y
        tu equipo podréis crear citas desde el panel.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-switch-solo-clientes',
    content: (
      <div style={{ textAlign: 'justify' }}>
        <strong>Permitir reservas solo a clientes registrados</strong>: si lo
        activas, solo quien tenga cuenta de cliente en Bookoll podrá reservar.
        Se acabaron las reservas de desconocidos sin registrar.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-switch-dias',
    content: (
      <div style={{ textAlign: 'justify' }}>
        <strong>Días visibles en reservas online</strong>: define cuántos días
        hacia adelante puede ver un cliente al reservar. Por ejemplo, 14
        muestra las dos próximas semanas; puedes ajustarlo entre 1 y 60 días.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-card-notifications',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Esta sección gestiona las <strong>notificaciones automáticas por
        correo</strong>. Bookoll puede avisar a los clientes, trabajadores y
        gestores cada vez que se crea, modifica o cancela una cita. Vamos a
        ver cada aviso por separado.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-switch-notifica_cliente_email',
    content: (
      <div style={{ textAlign: 'justify' }}>
        <strong>Aviso al cliente</strong>: envía por correo la confirmación de
        la cita y cualquier cambio o cancelación posterior.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-switch-notifica_trabajador_email',
    content: (
      <div style={{ textAlign: 'justify' }}>
        <strong>Aviso al trabajador</strong>: le llega un correo cuando se le
        asigna una nueva cita o cuando alguna de las suyas se modifica.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-switch-notifica_gestor_email',
    content: (
      <div style={{ textAlign: 'justify' }}>
        <strong>Aviso al gestor</strong>: te envía una copia a ti (o a quien
        gestione el negocio) de toda la actividad de reservas, para tener un
        seguimiento centralizado sin depender de mirar el calendario.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-card-reminders',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Aquí configuras los <strong>recordatorios automáticos</strong> que se
        envían antes de cada cita, para reducir las ausencias.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-switch-recordatorio-activo',
    content: (
      <div style={{ textAlign: 'justify' }}>
        <strong>Recordatorio por email</strong>: actívalo para que se envíe un
        correo recordatorio antes de cada cita, tanto al cliente como al
        trabajador.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-switch-recordatorio-horas',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Define <strong>cuántas horas antes de la cita</strong> se envía el
        recordatorio (entre 1 y 72 horas).
        <ul style={{ margin: '8px 0 0 16px' }}>
          <li>
            <strong>24</strong> → se envía un día antes de la cita.
          </li>
          <li>
            <strong>2</strong> → se envía dos horas antes.
          </li>
        </ul>
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-save-btn',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Cuando termines de ajustar todo, pulsa
        <strong> Guardar cambios</strong> para aplicar la configuración.
        <br />
        <br />
        Si todo va bien, verás un mensaje de confirmación en pantalla.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-help-btn',
    content: (
      <div style={{ textAlign: 'justify' }}>
        En cualquier momento puedes volver a hacer clic en este botón
        <strong> Ayuda</strong> (arriba a la derecha) para repetir el tour
        completo y recordar qué hace cada parte de la página.
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },
];

export default CompanySettingsTourSteps;